<template>
    <section id="home_one_banner_cars">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <div class="banner_one_text">
                        <h1>{{$t("carRent")}}</h1>
                        <h3>{{$t("carMember")}}</h3>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: "BannerCars"
};
</script>